import React from "react";
import "./HeroVideo.css";

import heroPoster from "../../../Assets/images/amplehouseentrance.jpg";
import heroVideo from "../../../Assets/videos/training.mp4";

const HeroVideo = ({ children }) => {
  return (
    <div className="hero-video-wrapper">

      {/* Background Video */}
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        poster={heroPoster}
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Brand Overlay */}
      <div className="hero-video-overlay"></div>

      {/* Content */}
      <div className="hero-video-content">
        {children}
      </div>

    </div>
  );
};

export default HeroVideo;